import { InboxOutlined } from '@ant-design/icons';
import { Button, Col, Modal, Popover, Radio, Row, Upload } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { allowedFileCriteria } from '../../../utils/fileUtils';
import { HasAccess } from '@permify/react-role';

const UploadDocumentModal = ({
  open,
  closeModal,
  uploadFunction,
  loading,
}) => {
  const { t } = useTranslation();
  const [document, setDocument] = useState();
  const [addToReport, setAddToReport] = useState(undefined);

  const loadDocument = (file) => {
    setDocument(file)
  }

  const uploadConsent = async () => {
    if (!addToReport || (addToReport && allowedFileCriteria(t, document))) {
      await uploadFunction(document, addToReport)
      setDocument(undefined)
      setAddToReport(undefined)
      closeModal();
    }
  }

  const TooltipContent = () => (
    <div className='modal-tooltip'>
      <div className='pb-10'><strong>{t('examPage.uploadDocumentModal.tooltipTitle')}</strong></div>
      <div>{t('examPage.uploadDocumentModal.tooltipText')}</div>
    </div>
  )

  return (
    <Modal
      open={open}
      centered
      footer={false}
      closable
      onCancel={closeModal}
      className='upload-document-modal'
      width={800}
      responsive
      destroyOnClose
    >
      <HasAccess
        roles={['super_usuario', 'equipo_medico', 'equipo_psicologia', 'equipo_medico_externo']}
      >
        <div className='pt-80 pl-100 pr-100'>
          <Upload.Dragger
            maxCount={1}
            fileList={document ? [document] : []}
            onRemove={() => {
              setDocument(undefined);
            }}
            beforeUpload={file => {
              loadDocument(file);
              return false;
            }}
          >
            <p>
              <InboxOutlined className="inbox-icon" />
            </p>
            <p className="ant-upload-text mb-20 upload-text"><strong>{t("examPage.uploadDocumentModal.modalFileInstruction")}</strong></p>
            <p className="ant-upload-hint mb-20">
              {t("examPage.uploadDocumentModal.modalFileRestriction")}
            </p>
          </Upload.Dragger>
          <Row justify="center" className='mt-40 mb-30'>
            <div className='title-text'>{t("examPage.uploadDocumentModal.radioButtonInstruction")}</div>
          </Row>
          <Row justify="center" className='pb-20'>
            <div className='title-text'>
              <strong>{t("examPage.uploadDocumentModal.radioButtonTitle")}</strong>
            </div>
          </Row>
          <Row justify="space-around">
            <Col span={7}>
              <Radio.Group className="cmt-radio modal-radio-group" onChange={(value) => setAddToReport(value.target.value)}>
                <Popover content={<TooltipContent />} placement="top">
                  <Radio value={true}>{t("examPage.uploadDocumentModal.radioYes")}</Radio>
                </Popover>
                <Radio value={false}>{t("examPage.uploadDocumentModal.radioNo")}</Radio>
              </Radio.Group>
            </Col>
          </Row>
          <Row justify="center" className='mt-40 mb-30'>
            <div>
              <Button
                className={`cmt-button ${(!document || addToReport === undefined) ? "disabled" : "primary"} 
                          pl-70 pr-70`}
                type="primary"
                loading={loading.documents}
                onClick={uploadConsent}
                disabled={!document || addToReport === undefined}
                size="large">
                {t("examPage.uploadDocumentModal.saveButton")}
              </Button>
            </div>
          </Row>
        </div>
      </HasAccess>
    </Modal>
  )
};

export default UploadDocumentModal;